import React from 'react'
import { Text, View, TouchableOpacity, Image, Dimensions, ImageBackground } from 'react-native'
import { Feather } from '@expo/vector-icons'
import styles from './GamificationFinishStyles'
import styles2 from './GamificationGameStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import theme from '../../../theme'
import { GamificationFinishTheme } from '../../../themeConstants'

const width = Dimensions.get('window').width
export const GamificationFinish = ({ timeOut, approved, is_connect, exit }) => {
    const { languageFile } = getLanguage()

    if (timeOut) {
        const background = require('../../../assets/gamification/backgroundTriviaTimeup.png')
        const imagePath = require('../../../assets/gamification/timeupAsset.gif')
        const labelPath = require('../../../assets/gamification/labelDisapproved.png')
        const feedbackTitle = '¡TIEMPO AGOTADO!'
        const feedbackDescription = 'Vuelve a intentarlo\n¡Más suerte en la próxima partida!'

        return (
            <ImageBackground source={background} style={styles.imageBackground} resizeMode='cover'>
                <View style={[styles.feedbackContainer]}>
                    <View style={[styles.feedbackAssetContainer]}>
                        <Image style={styles2.feedbackAsset} source={imagePath} resizeMode='contain' />
                    </View>

                    <View style={styles.feedbackInfoContainer}>
                        <ImageBackground style={styles.labelAsset} source={labelPath} resizeMode='contain'>
                            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                                <Text style={styles.feedbackTitle}>{feedbackTitle}</Text>
                                <Text style={styles.feedbackDescription}>{feedbackDescription}</Text>
                            </View>
                        </ImageBackground>
                        <View style={styles.paddingBottom}></View>
                    </View>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 0 }} onPress={() => exit()}>
                            <Image
                                source={require('../../../assets/gamification/gami_game_back_ap.png')}
                                style={{ width: 200, aspectRatio: 2 / 1.1 }}
                                resizeMode='contain'
                            />

                            <Text
                                style={{
                                    position: 'absolute',
                                    flex: 1,
                                    color: GamificationFinishTheme.exitButtonTextColorAp,
                                    fontSize: 16,
                                    fontWeight: 'bold',
                                    justifyContent: 'center',
                                    paddingBottom: 7,
                                }}
                            >
                                Salir
                            </Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </ImageBackground>
        )
    } else {
        const backgroundTrivia = approved
            ? require('../../../assets/gamification/backgroundTriviaApproved.png')
            : require('../../../assets/gamification/backgroundTriviaDisapproved.png')
        const imagePath = approved
            ? require('../../../assets/gamification/triviaApproved.gif')
            : require('../../../assets/gamification/triviaDisapproved.gif')
        const labelPath = approved
            ? require('../../../assets/gamification/labelApproved.png')
            : require('../../../assets/gamification/labelDisapproved.png')
        const feedbackTitle = approved ? languageFile.congratulations : languageFile.game_again
        const feedbackDescription = approved ? languageFile.game_OK : languageFile.game_rulette_again
        const backPath = approved
            ? require('../../../assets/gamification/gami_game_back_ap.png')
            : require('../../../assets/gamification/gami_game_back_dis.png')

        return (
            <ImageBackground
                source={backgroundTrivia}
                style={{
                    width: '100%',
                    height: '100%',
                }}
                resizeMode='cover'
            >
                <View style={[styles2.feedbackContainer]}>
                    <View style={[styles2.feedbackAssetContainer]}>
                        <Image style={styles2.feedbackAsset} source={imagePath} resizeMode='contain' />
                    </View>

                    <View style={styles2.feedbackInfoContainer}>
                        <ImageBackground
                            style={{
                                marginTop: 8,
                                width: width,
                                height: 165,
                            }}
                            source={labelPath}
                            resizeMode='contain'
                        >
                            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                                <Text style={styles2.feedbackTitle}>{feedbackTitle}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                                <Text style={[styles2.feedbackDescription, { color: approved ? theme.colors.colorPrimary : theme.colors.error }]}>
                                    {feedbackDescription}
                                </Text>
                            </View>
                        </ImageBackground>
                    </View>

                    <View style={styles2.buttonContainer}></View>
                    <View
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            position: 'absolute',
                            bottom: 45,
                            width: '100%',
                        }}
                    >
                        {approved ? (
                            <TouchableOpacity onPress={() => exit()}>
                                <View
                                    style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: 16,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                    }}
                                >
                                    <Feather name='x' size={24} color={'white'} />
                                </View>
                            </TouchableOpacity>
                        ) : (
                            <TouchableOpacity style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 0 }} onPress={() => exit()}>
                                <Image source={backPath} style={{ width: 200, aspectRatio: 2 / 1.1 }} resizeMode='contain' />

                                <Text
                                    style={{
                                        position: 'absolute',
                                        flex: 1,
                                        color: GamificationFinishTheme.exitButtonTextColorDis,
                                        fontSize: 16,
                                        fontWeight: 'bold',
                                        justifyContent: 'center',
                                        paddingBottom: 7,
                                    }}
                                >
                                    Salir
                                </Text>
                            </TouchableOpacity>
                        )}
                    </View>
                </View>
            </ImageBackground>
        )
    }
}
